import i18n from 'i18n'
import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    {label: 'Package', value: 'package'},
    {label: 'Hotel', value: 'hotel'},
    {label: 'Location', value: 'location'},
]

// Display-only: value es identidad; solo se traduce el texto.
const MAPPING_KEY = { package: 'common:filters.mappingPackage', hotel: 'common:filters.mappingHotel', location: 'common:filters.mappingLocation' }

export default function SelectMappingType({...props}) {
    const myProps = {
        placeholder: i18n.t('common:filters.allMappingType'),
        formatOptionLabel: opt => i18n.t(MAPPING_KEY[opt?.value] || '', { defaultValue: opt?.label }),
        firstSelect: true,
        options: OPTIONS,
        icon: {icon: 'map-signs'},
        isMulti: false,
        ...props
    }

    return <SelectSeeker {...myProps} />
}